module.exports = __webpack_public_path__ + "static/media/Header 5.e333a720.svg";